import { Component, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, filter, fromEvent, map, pluck } from 'rxjs';

@Component({
  selector: 'split-search',
  templateUrl: './split-search.component.html',
  styleUrls: ['./split-search.component.scss']
})
export class SplitSearchComponent {
  @ViewChild('inputSearch') public searchInput: any;
  formControl = new FormControl('');
  constructor(private renderer: Renderer2) {}

  @Input() set value(value : any) {
    this.formControl.setValue(value);
  } 
  @Input() placeholder: string = "Pesquisar";

  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Output() onSearch: EventEmitter<string> = new EventEmitter();

  ngAfterViewInit() {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(
        map((event: any) => event.target.value),
        debounceTime(1000)
      )
      .subscribe((value: any) => {
        this.valueChange.emit(value);
        this.onSearch.emit(value);
      });
  }

  clear() {
    this.formControl.setValue(''); 
    this.valueChange.emit(''); 
    this.onSearch.emit(''); 
  }

}
